.body {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: var(--pgm-sys-spacing-6);
  margin: 0 auto;
  max-width: 1600px;
  padding: var(--pgm-sys-spacing-6) var(--pgm-sys-spacing-6) var(--pgm-sys-spacing-16);
  width: 100%;
}

.grid {
  align-items: start;
  display: grid;
  gap: var(--pgm-sys-spacing-6);
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

@media (max-width: 1024px) {
  .grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 599.98px) {
  .body {
    padding: var(--pgm-sys-spacing-4) var(--pgm-sys-spacing-4) var(--pgm-sys-spacing-12);
  }

  .grid {
    grid-template-columns: minmax(0, 1fr);
  }
}
